/* eslint-disable react/forbid-foreign-prop-types */
import PropTypes from 'prop-types';
import LayoutProps from 'admin-components/proptypes/groups/layout';

export const propTypes = {
  size: PropTypes.oneOf(['small', 'regular', 'large']),
  italic: PropTypes.bool,
  bold: PropTypes.bool,
  children: PropTypes.node,
  color: PropTypes.string,
  ...LayoutProps.propTypes
};

export const defaultProps = {
  size: 'regular',
  italic: false,
  bold: false,
  ...LayoutProps.defaultProps
};

export const propDescriptions = {
  size: 'Sets the size of the text #visual',
  italic: 'Sets the text to be italic #visual',
  bold: 'Sets the text to be bold #visual',
  ...LayoutProps.propDescriptions
};
